import { Link, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import Panel from '../ui/Panel'
import VerdictPanel from '../features/leak-test/VerdictPanel'
import ResolverTable from '../features/leak-test/ResolverTable'
import ShareBars from '../charts/ShareBars'
import OrgConcentration from '../charts/OrgConcentration'
import WorldPlot from '../charts/WorldPlot'
import { fetchShare } from '../api/client'
import { fromShareRows } from '../lib/share'
import { leakTest } from '../content/site'
import type { IpDetails } from '@shared/api'
import styles from './LeakTest.module.css'

export default function SharedResult() {
    const { id = '' } = useParams()

    const share = useQuery({
        queryKey: ['share', id],
        queryFn: ({ signal }) => fetchShare(id, signal),
        enabled: Boolean(id),
        retry: false,
    })

    if (share.isPending) return <Panel title="Shared result"><p>Loading…</p></Panel>

    if (share.isError || !share.data) {
        return (
            <Panel title="Shared result">
                <h1 className={styles.emptyHeading}>{leakTest.emptyShare.heading}</h1>
                <p className={styles.para}>{leakTest.emptyShare.body}</p>
                <p className={styles.para}><Link to="/dns-leak-test">Run your own test</Link></p>
            </Panel>
        )
    }

    const rows = fromShareRows(share.data.leaktest)
    // the user block is the submitter's own details as recorded at share time
    const submitter = share.data.user as unknown as IpDetails & { ip?: string }

    return (
        <>
            <div className={styles.head}>
                <h1>Shared DNS leak test for <span className={styles.subject}>{submitter.ip ?? '—'}</span></h1>
                <Link to="/dns-leak-test">{leakTest.actions.retest}</Link>
            </div>

            <VerdictPanel rows={rows} self={submitter} />

            {rows.length > 0 && (
                <div className={styles.charts}>
                    <ShareBars rows={rows} />
                    <OrgConcentration rows={rows} self={submitter} />
                </div>
            )}

            <div className={styles.section}>
                <Panel title="Resolvers">
                    <ResolverTable rows={rows} self={submitter} />
                </Panel>
            </div>

            {rows.length > 0 && (
                <div className={styles.section}>
                    <WorldPlot rows={rows} self={submitter} />
                </div>
            )}
        </>
    )
}
